module.exports = __webpack_public_path__ + "img/c3.9267b6f4.png";